import { useState, useEffect, useRef, useCallback } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../Lib/contextLib';
import { getVideo, GetUserVideo } from '../../s3Func/s3Download';
import { API, Auth } from 'aws-amplify';
import PopUp from '../../Popup/logoutPopup';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './Module15World.css';
import Draggable from 'react-draggable';

import Learn from '../../Learn/Learn';
import Practice from './Practice';
import SingingTime from '../../SingingTime/SingingTime';
import Celebrate from '../../Celebrate/Celebrate';
import Surprise from '../../SurpriseVideo/surprise';
import FollowTheBeatModule10 from '../../FollowTheBeat/FollowTheBeatModule10.js';
import presentSound from './../../Unit1/Module1/assets/ta_da_gift.mp3';

const Module15World = () => {
  const [clientHeight, setVh] = useState(window.innerHeight);
  const [clientWidth, setVw] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setVh(window.innerHeight);
      setVw(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [clientHeight, clientWidth]);
  const { userHasAuthenticated } = useAppContext();
  const dispatch = useDispatch();
  const { module15 } = useSelector((state) => state.module15, shallowEqual);
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const background = generateImageUrl('images/Module15Images/m15-BG-chromebook.png');
  const bg = generateImageUrl('images/Module15Images/U3m5_Sky.png');
  const animal = generateImageUrl('images/Module5Images/Bird+Closing+still.gif');
  let progressbar0 = generateImageUrl("images/Module5Images/Mod5_ProgressBar_0.svg");
  let progressbar1 = generateImageUrl("images/Module5Images/Mod5_ProgressBar_Third.svg");
  let progressbar2 = generateImageUrl("images/Module5Images/Mod5_ProgressBar_2Thirds.svg");
  let progressbar3 = generateImageUrl("images/Module5Images/Mod5_ProgressBar_2Thirds.svg");
  let progressbarCompleted = generateImageUrl("images/Module5Images/Mod5_ProgressBar_Completed.svg");
  const journeyImage = generateImageUrl('images/Module1Images/bluejourneymap.svg');
  const coinPick = generateImageUrl('images/Images/AwesomeCoin.png');
  const coinBar = generateImageUrl('images/Images/Coin+Counter.png');
  const logoutBtn = generateImageUrl('images/Module1Images/Logout.png');
  const reviewBtn = generateImageUrl('images/Module1Images/Button_Review.png');
  const rewardBtn = generateImageUrl('images/Module1Images/Button_Reward_3x.png')
  const celebrateBtn = generateImageUrl('images/Module1Images/Button_Celebrate.png');
  const learnBtn = generateImageUrl('images/Module1Images/Button_Learn.png');
  const practiceBtn = generateImageUrl('images/Module1Images/Button_Practice.png');
  const ftbBtn = generateImageUrl('images/Images/Button_FTB.png');
  const keyReward = generateImageUrl('images/Module5Images/Worm.png');
  let nest = generateImageUrl('images/Module20Images/Nest.svg');
  const Egg = generateImageUrl('images/Module5Images/Egg.png');
  const eggBottom = generateImageUrl('images/Module5Images/Egg+Crack+Bottom.png');
  const eggTop = generateImageUrl('images/Module5Images/Egg+Crack+Top.png');
  const Tree = generateImageUrl('images/Module15Images/Tree.png');
  const TreeHouseRed = generateImageUrl('images/Module5Images/Reward_BirdhousePink.png');
  const TreeHouseBlue = generateImageUrl('images/Module5Images/Reward_BirdhouseBlue.png');
  const Alien1 = generateImageUrl('images/Module10Images/DailyReward_Alien1.png');
  const Alien2 = generateImageUrl('images/Module10Images/DailyReward_Alien2.png');
  const TelescopeRed = generateImageUrl('images/Module5Images/Reward_TelescopeRed.png');
  const TelescopeBlue = generateImageUrl('images/Module5Images/Reward_TelescopeBlue.png');
  const CometOrange = generateImageUrl('images/Module10Images/DailyReward_CometOrange.png');
  const CometBlue = generateImageUrl('images/Module10Images/DailyReward_CometBlue.png');
  const Deer = generateImageUrl('images/Module5Images/Reward_DeerMale.png');
  const Doe = generateImageUrl('images/Module5Images/Reward_DeerFemale.png');
  const Planet1 = generateImageUrl('images/Module10Images/DailyReward_Planet1.png');
  const Planet2 = generateImageUrl('images/Module10Images/DailyReward_Planet2.png');
  const Swing = generateImageUrl('images/Module5Images/Reward_WoodenSwing.png');
  const TireSwing = generateImageUrl('images/Module5Images/Reward_TireSwing.png');
  const Rocket1 = generateImageUrl('images/Module10Images/DailyReward_Rocket1.png');
  const Rocket2 = generateImageUrl('images/Module10Images/DailyReward_Rocket2.png');
  let NorthernLights = generateImageUrl('images/Module15Images/BigReward_NorthLights.png');
  let Galaxy = generateImageUrl('images/Module10Images/BigReward_Galaxy.png');
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png');
  const SingingTimeIcon = generateImageUrl('images/Module1Images/Button_SingingTime.png');
  const AfterCelebrateVideo9 = '31a58095e81d4ed6bd2b949b6e5c/480.m3u8';
  const present = generateImageUrl('images/Images/Gift.png');
  const eggCrackAudio = new Audio(generateImageUrl('media/Module5Videos/egg_crack.mp3'))
  const eggHalfCracked = generateImageUrl('images/Module5Images/EggCrack_3.png');

  const [reviewIcon, setReviewIcon] = useState(false);
  const [keyIcon, setKeyIcon] = useState(false);
  const [coinIcon, setCoinIcon] = useState(false);
  const [presentIcon, setPresentIcon] = useState(false);
  const [rewardOption1, setRewardOption1] = useState(null);
  const [rewardOption2, setRewardOption2] = useState(null);
  const [displayReward, setDisplayReward] = useState(false);

  const [eggAnimate, setEggAnimate] = useState(false);
  const [eggAnimationState, setEggAnimationState] = useState('');

  const [displayLearn, setDisplayLearn] = useState(false);
  const [displayPractice, setDisplayPractice] = useState(false);
  const [displayDay4Practice, setDisplayDay4Practice] = useState(false);
  const [displaySingingTime, setDisplaySingingTime] = useState(false);
  const [displayFTB, setDisplayFTB] = useState(false);
  const [displayCelebrate, setDisplayCelebrate] = useState(false);
  const [displaybody, setDisplayBody] = useState(true);
  const [displayGreenButton, setdisplayGreenButton] = useState(false);
  const [learn, setLearn] = useState('');
  const [practice, setPractice] = useState('');
  const [singTime, setSingTime] = useState('');
  const [celebrate, setCelebrate] = useState('');
  const firstUpdate = useRef(true);
  const coinUpdate = useRef(true);
  const [displayIntroVideo, setDisplayIntroVideo] = useState(false);
  const [introVideo, setIntroVideo] = useState('');
  const [displaySurprise, setDisplaySurprise] = useState(false);
  const [surpriseVideo, setSurpriseVideo] = useState('');
  const [displayVoice, setDisplayVoice] = useState(false);
  const [animalVoice, setAnimalVoice] = useState('');
  const [day4Practice, setDay4Practice] = useState('');
  const [prize, setPrize] = useState(false);
  const [disPlayPrize, setDisplayPrize] = useState(false);
  const [checkStep, setCheckStep] = useState('');

  const [keyState, setKeyState] = useState('');
  const [eggHalf, setEggHalf] = useState(false);
  const [eggState, setEggState] = useState(Egg);

  const keys5 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];
  const keys4 = [
    progressbar0,
    progressbar1,
    progressbar2,
    progressbar3,
    progressbarCompleted,
  ];

  const [touchButton, setTouchButton] = useState(false);
  const [checkSound, setCheckSound] = useState(false);
  const [buttonSound, setButtonSound] = useState(false);
  const [rewardsFound, setRewardsFound] = useState(false);
  const [coinAnimationState, setCoinAnimationState] = useState('bounceIcons');
  const [coinAudio, setCoinAudio] = useState(false);

  const [specialMessage, setSpecialMessage] = useState(false);
  const [watchConversation, setWatchConversation] = useState(false);
  const [practiceIntro, setPracticeIntro] = useState('');
  const [learnIntro, setLearnIntro] = useState('');
  const [ftbIntro, setFtbIntro] = useState('');
  const [celebrateIntro, setCelebrateIntro] = useState('');
  const [animalClose, setAnimalClose] = useState(false);
  const [playAnimalClose, setPlayAnimalClose] = useState(false);
  const [animalCloseAudio, setAnimalCloseAudio] = useState(false);
  const [showAnimal, setShowAnimal] = useState(false);
  const [animalState, setAnimalState] = useState('');
  const [amazingJob, setAmazingJob] = useState(false);
  const [birdAwesomeJobGIF, setBirdAwesomeJobGIF] = useState(false);
  const [showReward, setShowReward] = useState(false);

  let [ftbMusic, setFTBMusic] = useState("");
  let [ftbInstruction, setFTBInstruction] = useState("");
  let [ftbInstructionGIF, setFTBInstructionGIF] = useState("");
  let [ftbCount, setFTBCount] = useState("");
  let [ftbTutorial1, setFTBTutorial1] = useState("");
  let [ftbTutorial2, setFTBTutorial2] = useState("");
  let [ftbWT, setFTBWalkThrough] = useState("");
  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'));

  const influencers = [
    login.influencerid,
    login.influencerid1,
    login.influencerid2,
    login.influencerid3,
    login.influencerid4,
  ];

  const playButtonAudio = useCallback(() => {
    sleep(700).then(() => {
      setButtonSound(true);
    });
  }, []);

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function getGifs() {
    setSpecialMessage(getVideo('appfiles/close/practice special message.gif', login));
    setWatchConversation(getVideo('appfiles/close/practice watch conversation.gif', login));
    setAmazingJob(getVideo('appfiles/close/close_awesome_job.mp3', login));
    setBirdAwesomeJobGIF(getVideo('appfiles/close/awesome job.gif', login));
    setPracticeIntro(getVideo('appfiles/close/practice intro.gif', login));
    setLearnIntro(getVideo('appfiles/caring/caring_learn_intro.gif', login));
    setFtbIntro(getVideo('appfiles/close/ftb intro.gif', login));
    setCelebrateIntro(getVideo('appfiles/close/close_celebrate_intro.gif', login));
    setAnimalClose(getVideo('appfiles/close/day finished.gif', login));
    setAnimalCloseAudio(getVideo('appfiles/active_listening/active_listening_day_finished.mp3', login));
    setFTBInstruction(getVideo('appfiles/active_listening/active_listening_ftb_instructions.mp3', login));
    setFTBInstructionGIF(getVideo('appfiles/close/FTB intructions.gif', login));
    setFTBMusic(getVideo('appfiles/close/close_ftb_audio.m4a', login));
    setFTBCount(getVideo('appfiles/close/countingBird.gif', login));

    if (!module15.unlockedDays.day2) {
      setFTBTutorial1(getVideo('appfiles/greet/ftb_walkthrough_touch_circle.mp3', login));
      setFTBTutorial2(getVideo('appfiles/active_listening/ftb_walkthrough_tap.mp3', login));
      setFTBWalkThrough(getVideo('appfiles/close/ftb_walkthrough_audio.mp3', login));
    }
  }

  useEffect(() => {
    getGifs();
  }, []);

  const createGameDetails = useCallback(
    (flag, reward, coin) => {
      const game_detail = module15.game_details;
      if (flag) {
        const flags = { flag, lastUpdated: new Date().toJSON() };
        game_detail.moduleFlags.psuh(flags);
      }
      if (coin >= 0) {
        game_detail.tokens_earned = coin;
      }
      if (reward) {
        const dailyRewards = [];
        for (const key in module15.rewards) {
          if (module15.rewards[key].unlocked === true) {
            const rewards = {
              type: key,
              x_multiplier: module15.rewards[key].x,
              y_multiplier: module15.rewards[key].y,
            };
            dailyRewards.push(rewards);
          }
        }
        game_detail.dailyRewards = dailyRewards;
      }
      dispatch({ type: 'MODULE15_SET_GameDetials', payload: game_detail });
    },
    [dispatch, module15.game_details, module15.rewards]
  );

  const updateProgress = (async () => {
		const payload = {
			body: {
				id: login.studentid,
				module: "ActiveListening",
				day_completed: module15.currentday,
				time_completed: new Date().toDateString(),
			},
		}
		await API.put('TIR', '/v3/student/progress', payload)
		.then((response) => {
		})
		.catch((error) => {
		});
	})

  const updateDB = useCallback(async () => {
    const myInit = {
      body: {
        id: module15.moduleID,
        day_completed: module15.day_completed,
        step_completed: module15.stepCompleted,
        game_details: JSON.stringify(module15.game_details),
      },
    };
    await API.put('TIR', '/v3/student/module', myInit)
      .then((response) => {
        if (displayGreenButton) {
          setShowAnimal(true);
          setPlayAnimalClose(true);
          setAnimalState(animalClose);
          setdisplayGreenButton(false);
          setDisplayReward(false);
        }
      })
      .catch(() => {
        if (
          module15.stepCompleted === 'notstarted' ||
          module15.stepCompleted === 'learn' ||
          module15.stepCompleted === 'practice' ||
          module15.stepCompleted === 'celebrate' ||
          module15.stepCompleted === 'followthebeat'
        ) {
          window.alert('Connection is lost. Please login again.');
          dispatch({ type: 'CLEAR' });
          Auth.signOut();
          navigate('/');
        }
      });
      const myInit2 = {
        body: {
          id: login.studentid,
          current_module: 'ActiveListening',
        },
      };
      await API.put('TIR', '/v3/student', myInit2)
      .then((response) => {
      })
      .catch((error) => {
      });
  });

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    } else {
      if(login.grade !== "Teacher Mode" && login.grade !== 'Free Play'){
        updateDB();
      }
    }
  }, [module15.stepCompleted]);

    useEffect(() => {
      if((module15.reviewIcon === true || login.grade === "Teacher Mode") && module15.sectionCompleted === 4 ) {
          updateProgress();
          module15.sectionCompleted = 0;
      }
    }, [module15.sectionCompleted])

  useEffect(() => {
    if (module15.coins >= 100) {
      setPrize(true);
    }
    if (coinUpdate.current) {
      coinUpdate.current = false;
    } else {
      createGameDetails(false, false, module15.coins);
      updateDB();
    }
  }, [module15.coins]);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (module15.currentday <= module15.day_completed || login.grade === "Teacher Mode" || login.grade === "Free Play") {
      if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
        setShowReward(true)
      }
      dispatch({ type: 'MODULE15_TOGGLE_REVIEW_ICON', payload: true });
      dispatch({ type: 'MODULE15_SET_KEY', payload: 4 });
      if (module15.currentday === 4 || module15.currentday === 8) {
        dispatch({ type: 'MODULE15_SET_KEY', payload: 5 });
      }
    } else {
      if (module15.stepCompleted === checkStep) {
        setCoinIcon(true);
      }
      dispatch({ type: 'MODULE15_TOGGLE_REVIEW_ICON', payload: false });
      if (module15.currentday === 4 && module15.day_completed === 3) {
        if (module15.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE15_SET_KEY', payload: 0 });
        } else if (module15.stepCompleted === 'singingtime') {
          dispatch({ type: 'MODULE15_SET_KEY', payload: 1 });
        } else if (module15.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE15_SET_KEY', payload: 2 });
        } else if (module15.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE15_SET_KEY', payload: 3 });
        } else if (module15.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE15_SET_KEY', payload: 4 });
        } else if (module15.stepCompleted === 'celebrate') {
          setKeyIcon(true);
          dispatch({ type: 'MODULE15_SET_KEY', payload: 5 });
        }
        playButtonAudio();
      } else {
        if (module15.stepCompleted === 'notstarted') {
          dispatch({ type: 'MODULE15_SET_KEY', payload: 0 });
        } else if (module15.stepCompleted === 'learn') {
          dispatch({ type: 'MODULE15_SET_KEY', payload: 1 });
        } else if (module15.stepCompleted === 'practice') {
          dispatch({ type: 'MODULE15_SET_KEY', payload: 2 });
        } else if (module15.stepCompleted === 'followthebeat') {
          dispatch({ type: 'MODULE15_SET_KEY', payload: 3 });
        } else if (module15.stepCompleted === 'celebrate') {
          if (module15.currentday === 8 && module15.day_completed === 7) {
            dispatch({ type: 'MODULE15_SET_KEY', payload: 4 });
            setPresentIcon(true);
          } else {
            setKeyIcon(true);
            dispatch({ type: 'MODULE15_SET_KEY', payload: 4 });
          }
        } else if (module15.stepCompleted === 'surprise') {
          dispatch({ type: 'MODULE15_SET_KEY', payload: 5 });
          setKeyIcon(true);
        }
        playButtonAudio();
      }
    }
  }, [module15.stepCompleted]);

  let [displayGreenCheck, setDisplayGreenCheck] = useState(false);
  let [dropZone, setDropZone] = useState(false);

  const selectReward = () => {
    return (
      <>
        <div className='rewards'  id ='rewardList'>
          <div className='circle' id='rewardItemLeft2'>
            <img
              src={rewardOption1}
              alt=''
              onClick={() => {
                dispatch({
                  type: `MODULE15_SET_REWARD${module15.currentday}1`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE15_SET_REWARD${module15.currentday}2`,
                  payload: false,
                });
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight2'>
            <img
              src={rewardOption2}
              alt=''
              onClick={() => {
                dispatch({
                  type: `MODULE15_SET_REWARD${module15.currentday}2`,
                  payload: true,
                });
                dispatch({
                  type: `MODULE15_SET_REWARD${module15.currentday}1`,
                  payload: false,
                });
                document.getElementById('rewardItemRight2').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft2').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                // document.getElementById("rewardList").style.zIndex = 1;
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true);
            }}/>}
        </div>
        {dropZone && <div class="area">
          <div id="dropZone">
            <div id ='word'>Drag and drop your item</div>
          </div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setCheckSound(true);
                setDropZone(false);
                updateProgress();
                sleep(500).then(() => {
                  createGameDetails(false, true);
                  if(login.grade === "Teacher Mode" || login.grade === "Free Play"){
                    updateDB();
                  }
                  dispatch({
                    type: `MODULE15_SET_DAY_UNLOCK${module15.currentday + 1}`,
                    payload: true,
                  });
                  dispatch({
                    type: 'MODULE15_SET_dayCompleted',
                    payload: module15.currentday === 8 ? 9 : module15.currentday,
                  });
                  dispatch({
                    type: 'MODULE15_SET_stepCompleted',
                    payload: 'notstarted',
                  });
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  const openPrize = () => {
    return (
      <>
        {!dropZone && <div className='rewards'>
            <div className='circle' id='rewardItemLeft'>
            <img
              src={NorthernLights}
              alt=''
              onClick={() => {
                dispatch({ type: 'MODULE15_SET_PRIZE1', payload: true });
                dispatch({ type: 'MODULE15_SET_PRIZE2', payload: false });
                document.getElementById('rewardItemLeft').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemRight').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
          <div className='circle' id='rewardItemRight'>
            <img
              src={Galaxy}
              alt=''
              onClick={() => {
                dispatch({ type: 'MODULE15_SET_PRIZE2', payload: true });
                dispatch({ type: 'MODULE15_SET_PRIZE1', payload: false });
                document.getElementById('rewardItemRight').style.borderColor =
                  'yellow';
                document.getElementById('rewardItemLeft').style.borderColor =
                  'white';
                setTouchButton(true);
                setDisplayGreenCheck(true);
              }}
            />
          </div>
        </div>}
        <div className='greenCheckDiv'>
            {displayGreenCheck && <img className='greenCheck' src={greenCheck} alt="" onClick={() => { 
                setCheckSound(true);
                setDropZone(true);
                setDisplayGreenCheck(false);
                setdisplayGreenButton(true);
            }}/>}
        </div>
        {dropZone && <div class="area">
          <div id="dropZone">
            <div id ='word'>Drag and drop your item</div>
          </div>
        </div>}
        <div className='greenCheckDiv'>
          {displayGreenButton && (
            <img
              className='greenCheck'
              src={greenCheck}
              alt=''
              onClick={() => {
                setDisplayPrize(false);
                setCheckSound(true);
                setDropZone(false);
                sleep(500).then(() => {
                  setdisplayGreenButton(false);
                  createGameDetails(false, true);
                  dispatch({
                    type: 'MODULE15_SET_COIN',
                    payload: module15.coins - 100,
                  });
                });
              }}
            />
          )}
        </div>
      </>
    );
  };

  useEffect(() => {
    switch (module15.currentday) {
      case 1:
        setRewardOption1(TreeHouseRed);
        setRewardOption2(TreeHouseBlue);
        break;
      case 2:
        setRewardOption1(Alien1);
        setRewardOption2(Alien2);
        break;
      case 3:
        setRewardOption1(TelescopeRed);
        setRewardOption2(TelescopeBlue);
        break;
      case 4:
        setRewardOption1(CometBlue);
        setRewardOption2(CometOrange);
        break;
      case 5:
        setRewardOption1(Deer);
        setRewardOption2(Doe);
        break;
      case 6:
        setRewardOption1(Planet1);
        setRewardOption2(Planet2);
        break;
      case 7:
        setRewardOption1(Swing);
        setRewardOption2(TireSwing);
        break;
      case 8:
        setRewardOption1(Rocket1);
        setRewardOption2(Rocket2);
        break;
      default:
        setdisplayGreenButton(true);
        break;
    }
  }, [
    keyIcon,
    Alien1,
    Alien2,
    CometBlue,
    CometOrange,
    Deer,
    Doe,
    TelescopeRed,
    Planet1,
    Planet2,
    Rocket1,
    Rocket2,
    Swing,
    TelescopeBlue,
    TireSwing,
    TreeHouseBlue,
    TreeHouseRed,
    module15.currentday,
  ]);

  const displayReview = () => {
    if (module15.currentday === 4) {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns41'
              src={SingingTimeIcon}
              alt='singing button'
              onClick={() => {
                displaySinging();
              }}
            />
            <img
              className='reviewBtns42'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns43'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns44'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns45'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className='world2reviewContainer'>
            <img
              className='reviewBtns1'
              src={learnBtn}
              alt='learn button'
              onClick={() => {
                openLearn();
              }}
            />
            <img
              className='reviewBtns2'
              src={practiceBtn}
              alt='practice button'
              onClick={() => {
                openPractice();
              }}
            />
            <img
              className='reviewBtns3'
              src={ftbBtn}
              alt='ftb button'
              onClick={() => {
                openFTB();
              }}
            />
            <img
              className='reviewBtns4'
              src={celebrateBtn}
              alt='celebrate button'
              onClick={() => {
                openCelebrate();
              }}
            />
          </div>
        </>
      );
    }
  };

  const introduction = () => {
    return (
      <div>
        <CloudfrontVideoFormat
          source={introVideo}
          back='/activelistening/navigation'
          background={background}
          token={login.cookie}
          ended={() => {
            // here is where you can add dispatch functions
            setDisplayIntroVideo(false);
            setDisplayBody(true);
            if (module15.currentday === 4) {
              dispatch({ type: 'MODULE15_SET_KEY', payload: 1 });
              playButtonAudio();
            }
            if (module15.day_completed === 9) {
              navigate('/activelistening/navigation');
            }
          }}
        />
      </div>
    );
  };

  const openLearn = async () => {
    let song = getVideo('appfiles/active_listening/active_listening_demo.m4a', login);
    let video = getVideo('appfiles/active_listening/learn_video.mp4', login);
    switch (module15.currentday) {
      case 1:
        setLearn(
          <Learn
            video='0562d84a2bfc7c1f6394050a0414/480.m3u8'
            songVideo={video}
            closingVideo='7ae108d4eeb7114c51f5e622e4e5/480.m3u8'
            destiny='/activelistening'
            song={song}
            back='/activelistening'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE15_SET_stepCompleted'
            module={module15}
          />
        );
        break;
      case 2:
        setLearn(
          <Learn
            video='0a1c135dc912ef48c1cc27731349/480.m3u8'
            songVideo={video}
            closingVideo='c6f2ec36098c018a3167050e2286/480.m3u8'
            destiny='/activelistening'
            song={song}
            back='/activelistening'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE15_SET_stepCompleted'
            module={module15}
          />
        );
        break;
      case 3:
        setLearn(
          <Learn
            video='c8a1bc4bc655aa6174cb9e25f6d5/480.m3u8'
            songVideo={video}
            closingVideo='f41a380047e15682f06a5d99c88c/480.m3u8'
            destiny='/activelistening'
            song={song}
            back='/activelistening'
            background={background}
            setDisplayLearn={setDisplayLearn}
            step_completed='MODULE15_SET_stepCompleted'
            module={module15}
          />
        );
        break;
      default:
        // setAnimalVoice(getVideo('appfiles/active_listening/active_listening_learn_intro.mp3', login));
        // setDisplayVoice(true);
        // setAnimalState(learnIntro);
        // setShowAnimal(true);
        await GetUserVideo(`userfiles/${module15.StudentID}/active_listening_play_day_music.m4a`).then((data) => {
          fetch(data).then((response) => {
            GetUserVideo(`influencers/${influencers[module15.currentday - 4]}/close_affirmation.mp4`).then((influencerVideo) => {
              if (response.status === 200) {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/activelistening'
                    song={data}
                    back='/activelistening'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE15_SET_stepCompleted'
                    module={module15}
                    instrumental={getVideo('appfiles/active_listening/active_listening_final.m4a', login)}
                    influencerVideo={influencerVideo}
                  />
                );
              } else {
                setLearn(
                  <Learn
                    songVideo={video}
                    destiny='/activelistening'
                    song={song}
                    back='/activelistening'
                    background={background}
                    setDisplayLearn={setDisplayLearn}
                    step_completed='MODULE15_SET_stepCompleted'
                    module={module15}
                    influencerVideo={influencerVideo}
                  />
                );
              }
            });
          });
        });
        break;
    }
    setDisplayLearn(true);
  };

  const openPractice = async () => {
    let voice1 = getVideo('appfiles/close/close_practice_watch_conversation.mp3', login);
    let voice2 = getVideo('appfiles/close/close_awesome_job.mp3', login);
    switch (module15.currentday) {
      case 1:
        setPractice(
          <Practice
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE15_SET_stepCompleted'}
            module={module15}
            name={`active_listening_practice_video_${module15.currentday}.mp4`}
            conversationGIF={watchConversation}
            conversationAudio={voice1}
            endAudio={voice2}
            endGIF={birdAwesomeJobGIF}
            specialMessage={specialMessage}
            animal={animal}
          />
        );
        break;
      case 2:
        setPractice(
          <Practice
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE15_SET_stepCompleted'}
            module={module15}
            name={`active_listening_practice_video_${module15.currentday}.mp4`}
            conversationGIF={watchConversation}
            conversationAudio={voice1}
            endAudio={voice2}
            endGIF={birdAwesomeJobGIF}
            specialMessage={specialMessage}
            animal={animal}
          />
        );
        break;
      case 3:
        setPractice(
          <Practice
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE15_SET_stepCompleted'}
            module={module15}
            name={`active_listening_practice_video_${module15.currentday}.mp4`}
            conversationGIF={watchConversation}
            conversationAudio={voice1}
            endAudio={voice2}
            endGIF={birdAwesomeJobGIF}
            specialMessage={specialMessage}
            animal={animal}
          />
        );
        break;
      default:
        setPractice(
          <Practice
            setDisplayPractice={setDisplayPractice}
            background={background}
            stepComplete={'MODULE15_SET_stepCompleted'}
            module={module15}
            name={`active_listening_practice_video_${
              module15.currentday + 1
            }.mp4`}
            conversationGIF={watchConversation}
            conversationAudio={voice1}
            endAudio={voice2}
            endGIF={birdAwesomeJobGIF}
          />
        );
        break;
    }
    setDisplayPractice(true);
  };

  const openFTB = async () => {
    // setAnimalVoice(getVideo('appfiles/close/close_ftb_intro.mp3', login));
    // setDisplayVoice(true);
    // setAnimalState(ftbIntro);
    // setShowAnimal(true);
    setDisplayFTB(true);
  };

  const openCelebrate = async () => {
    const celebrateVideo1 = '9ba92c8a95e89becc0e367b83e4b/480.m3u8';
    const celebrateVideo2 = '49de8940dd0f94f8138969132f7c/480.m3u8';
    const celebrateVideo3 = '33f28248a67714c297d45433b4dc/480.m3u8';

    switch (module15.currentday) {
      case 1:
        setCelebrate(
          <Celebrate
            module={module15}
            celebrateVideo={celebrateVideo1}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE15'}
          />
        );
        break;
      case 2:
        setCelebrate(
          <Celebrate
            module={module15}
            celebrateVideo={celebrateVideo2}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE15'}
          />
        );
        break;
      case 3:
        setCelebrate(
          <Celebrate
            module={module15}
            celebrateVideo={celebrateVideo3}
            background={background}
            setDisplayCelebrate={setDisplayCelebrate}
            moduleNum={'MODULE15'}
          />
        );
        break;
      default:
        // setAnimalVoice(getVideo('appfiles/close/close_celebrate_intro.mp3', login));
        // setDisplayVoice(true);
        // setAnimalState(celebrateIntro);
        // setShowAnimal(true);
        let voice1 = getVideo('appfiles/close/close_celebrate_record_believe.mp3', login);
        let voice2 = getVideo('appfiles/close/close_celebrate_say_believe.mp3', login);
        let voice3 = getVideo('appfiles/close/close_awesome_job.mp3', login);
        let animalGIF = getVideo('appfiles/active_listening/joyful jingle bird.gif', login);
        let animalVoice = getVideo('appfiles/active_listening/active_listening_joyful_jingle_intro.mp3', login);
        await GetUserVideo(`influencers/${influencers[module15.currentday - 4]}/close_affirmation.mp4`).then((influencerVideo) => {
          setCelebrate(
            <Celebrate
              world3={true}
              module={module15}
              background={background}
              voice1={voice1}
              voice2={voice2}
              voice3={voice3}
              animalGIF={animalGIF}
              animalVoice={animalVoice}
              text={
                'Record yourself in an excited voice and say, "I believe in me!"'
              }
              name={`active_listening_celebration_surprise_${
                module15.currentday + 1
              }.mp4`}
              influencerVideo={influencerVideo}
              animation={birdAwesomeJobGIF}
              animal={animal}
              setDisplayCelebrate={setDisplayCelebrate}
              moduleNum={'MODULE15'}
              bigAnimal={true}
            />
          );
        });
        break;
    }
    setDisplayCelebrate(true);
  };

  const displaySinging = async () => {
    const introVideo = '2fd7a449a516bef55bfdd5381e13/480.m3u8';
    let noteVideo = getVideo('appfiles/active_listening/active_listening_student_notes.mp4', login);
    let singingMusic = getVideo('appfiles/active_listening/active_listening_demo.m4a', login);
    let instrumental = getVideo('appfiles/active_listening/active_listening_instrumental.m4a', login);
    setSingTime(
      <SingingTime
        introVideo={introVideo}
        demoMusic={singingMusic}
        singingVideo={noteVideo}
        background={background}
        singingMusic={singingMusic}
        setDisplaySingingTime={setDisplaySingingTime}
        module={module15}
        moduleNum='MODULE15'
        name='active_listening'
        instrumental={instrumental}
        instrumentalURL={'appfiles/active_listening/active_listening_final.m4a'}
      />
    );
    setDisplaySingingTime(true);
  };

  // change it
  const getSurprise = async () => {

    const usePhoto = [
      {
        video: null,
      },
      {
        video: null,
      },
      {
        video: null,
      },
      {
        video: null,
      },
      {
        video: null,
      },
      {
        video: null,
      },
      {
        video: null,
      },
      {
        video: null,
      },
    ];
    
    const videoPaths = [
      `influencers/${login.influencerid}/close_affirmation.mp4`,
      `userfiles/${module15.StudentID}/active_listening_celebration_surprise_5.mp4`,
      `influencers/${login.influencerid1}/close_affirmation.mp4`,
      `userfiles/${module15.StudentID}/active_listening_celebration_surprise_7.mp4`,
      `influencers/${login.influencerid2}/close_video_message.mp4`,
      `influencers/${login.influencerid3}/close_affirmation.mp4`,
      `userfiles/${module15.StudentID}/active_listening_celebration_surprise_9.mp4`,
      `influencers/${login.influencerid4}/close_affirmation.mp4`,
    ];
    
    // Use a loop to simplify the repetitive code
    for (let i = 0; i < usePhoto.length; i++) {
      await GetUserVideo(videoPaths[i], login).then((data) => {
        usePhoto[i].video = data;
      });
    }
    
    return usePhoto;
  };

  const playSurpriseVideo = async () => {
    await getSurprise().then((photo) => {
      setSurpriseVideo(
        <Surprise
          background={background}
          music={getVideo('appfiles/active_listening/active_listening_instrumental.m4a', login)}
          animal={animal}
          back={'/'}
          slides={photo}
          setDisplaySurprise={setDisplaySurprise}
        />
      );
    });
    setDisplaySurprise(true);
    setKeyIcon(true);
    setPresentIcon(false);
  };

  const coinAnimation = () => {
    setCoinAnimationState('coinAnimation');
    setCoinAudio(true);
  };

  const eggAnimation = () => {
    setKeyState('fade-out');
    eggCrackAudio.play();
    setEggHalf(true);
    sleep(2000).then(() => {
      setEggHalf(false);
      setEggState(eggBottom);
      setEggAnimationState('eggAnimate');
      setEggAnimate(true);
      sleep(1500).then(() => {
        setRewardsFound(true);
        setDisplayReward(true);
        setKeyIcon(false);
      });
    });
  };

  const closeDay9Video = () => {
    setDisplayIntroVideo(true);
    setDisplayBody(false);
    setIntroVideo(AfterCelebrateVideo9);
  };

  const onStop = (reward, data) => {
    const position = { x: data.x / clientWidth, y: data.y / clientHeight };

    if (reward === 1 || reward === 2) {
      dispatch({
        type: `MODULE15_SET_PRIZE${reward}_POSITION`,
        payload: position,
      });
    } else {
      dispatch({
        type: `MODULE15_SET_REWARD${reward}_POSITION`,
        payload: position,
      });
    }
  };

  return (
    <>
      {playAnimalClose && (
        <audio
          autoPlay
          onEnded={() => {
            setPlayAnimalClose(false);
            module15.currentday === 8
              ? closeDay9Video()
              : navigate('/activelistening/navigation');
          }}
        >
          <source src={animalCloseAudio} type='audio/mp3' />
        </audio>
      )}
      {coinAudio && (
        <audio
          autoPlay
          onEnded={() => {
            dispatch({
              type: 'MODULE15_SET_COIN',
              payload: module15.coins + 1,
            });
            setCoinAudio(false);
            setCoinAnimationState('bounceIcons');
            setCoinIcon(false);
            playButtonAudio();
          }}
        >
          <source
            src={
              generateImageUrl('media/Module5Videos/earn_token.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {checkSound && (
        <audio
          autoPlay
          onEnded={() => {
            setCheckSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_accept_item.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {rewardsFound && (
        <audio autoPlay>
          <source
            src={
              generateImageUrl('media/Module2Videos/daily_rewards_present.mp3')
            }
          ></source>
        </audio>
      )}
      {touchButton && (
        <audio
          autoPlay
          onEnded={() => {
            setTouchButton(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/touch_button.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {buttonSound && (
        <audio
          autoPlay
          onEnded={() => {
            setButtonSound(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/button_bouncing.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      {displayVoice && (
        <audio
          autoPlay
          onEnded={() => {
            setDisplayVoice(false);
            setAnimalState('');
            setShowAnimal(false);
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
      {displayIntroVideo && introduction()}
      {!displayVoice && displayLearn && learn}
      {displayPractice && practice}
      {!displayVoice && displayFTB && (
        <FollowTheBeatModule10
          unit3={true} 
          setDisplayFTB={setDisplayFTB}
          awesomeJob={amazingJob}
          awesomeJobGIF={birdAwesomeJobGIF}
          instruction={ftbInstruction}
          instructionGIF={ftbInstructionGIF}
          song={ftbMusic}
          count={ftbCount}
          tutorial1={ftbTutorial1}
          tutorial2={ftbTutorial2}
          walkthrough={ftbWT}
          stepComplete={'MODULE15_SET_stepCompleted'}
          module={module15}
          score={'ftb_active_listening'}
        />
      )}
      {!displayVoice && displayCelebrate && celebrate}
      {displaySingingTime && singTime}
      {displaySurprise && surpriseVideo}
      {((displaybody &&
        !displayLearn &&
        !displayPractice &&
        !displaySingingTime &&
        !displayCelebrate &&
        !displaySurprise &&
        !displayFTB &&
        !displayDay4Practice) ||
        displayVoice) && (
        <div
          className='activeListeningWorldBody'
          style={{ backgroundImage: `url(${bg})` }}
        >
          <img className='activeListeningMountain' src={generateImageUrl('images/Module15Images/U3m5_Mountains.png')} alt='trre' />
          <div className='navigation'>
            <img
              className='logoutBtn'
              src={logoutBtn}
              alt='Logout Button'
              onClick={togglePopup}
            />
            <img
              className='JourneyBlueImage'
              src={journeyImage}
              alt='Navigation blue world'
              onClick={() => {
                navigate('/activelistening/navigation');
              }}
            />
          </div>
          {isOpen && (
            <PopUp
              content={
                <>
                  <b id='title'>
                    Are you sure you want to leave?
                    <br />
                  </b>
                  <button
                    id='logoutButton1'
                    className='logoutButton'
                    onClick={() => {
                      navigate('/');
                      userHasAuthenticated(false);
                      localStorage.setItem('token', 'false');
                    }}
                  >
                    YES
                  </button>
                  <button
                    id='logoutButton2'
                    className='logoutButton'
                    onClick={togglePopup}
                  >
                    NO
                  </button>
                </>
              }
              handleClose={togglePopup}
            />
          )}

          {prize && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          {prize && (
            <img
              className='prize'
              src={
                generateImageUrl('images/Images/prize.png')
              }
              alt='Logout Button'
              onClick={() => {
                setPrize(false);
                sleep(1400).then(() => {
                  sleep(1000).then(() => {
                    setDisplayPrize(true);
                  });
                });
              }}
            />
          )}
          {prize && (
            <button
              className='prize-button'
              onClick={() => {
                setPrize(false);
                setDisplayPrize(true);
              }}
            >
              {' '}
              <h5>Click Here</h5>
            </button>
          )}
          {disPlayPrize && openPrize()}

          <div className="Bird_Container" style={{zIndex: 5}}>
            {showAnimal && (
              <img className="birdCharacterGif" src={animalState} alt='monkey Icon'/>
            )}
            <img
              className="birdCharacter"
              src={animal}
              alt="bird Icon"
            />
            <img className="Bird_Egg" src={eggState} alt="Egg Icon" />
            <img className="Bird_Nest" src={nest} alt="Egg Icon" />
            {eggHalf && (
              <img
                className="Bird_Egg"
                src={eggHalfCracked}
                id={"eggFade"}
                alt="Egg Icon"
              />
            )}
            {eggAnimate && (
              <img
                className="Bird_Egg"
                src={eggTop}
                id={eggAnimationState}
                alt="Egg Icon"
              />
            )}
          </div>

          <div className='scoreBar'>
            <img
              className='scoreKey'
              src={coinBar}
              alt='crab Icon'
              
            />
            {module15.coins < 10 && (
              <h5 className='scoretext1'>{module15.coins}</h5>
            )}
            {module15.coins >= 10 && module15.coins < 100 && (
              <h5 className='scoretext10'>{module15.coins}</h5>
            )}
            {module15.coins >= 100 && (
              <h5 className='scoretext100'>{module15.coins}</h5>
            )}
            <p className='scoretext'>100</p>
          </div>

          {module15.currentday === 4 || module15.currentday === 8 ? (
            <div className='progressBar3'>
              <img
                className='progressKey3'
                src={keys5[module15.keys]}
                alt='crab Icon'
                
              />
              <h3 className='progresstext3'>{module15.keys}/5</h3>
            </div>
          ) : (
            <div className='progressBar3'>
              <img
                className='progressKey3'
                src={keys4[module15.keys]}
                alt='crab Icon'
                
              />
              <h3 className='progresstext3'>{module15.keys}/4</h3>
            </div>
          )}

          {!showAnimal &&
            !module15.reviewIcon &&
            !coinIcon &&
            !disPlayPrize && 
            !dropZone && (
              <div className='actionBtnDiv'>
                {module15.currentday === 4 &&
                  module15.stepCompleted === 'notstarted' && (
                    <img
                      id='bounceIcons'
                      className='actionBtn2'
                      src={SingingTimeIcon}
                      alt='learn button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          displaySinging();
                          setCheckStep('singingtime');
                        });
                      }}
                    />
                  )}
                {module15.currentday !== 4 &&
                  module15.stepCompleted === 'notstarted' && (
                    <img
                      id='bounceIcons'
                      className='actionBtn2'
                      src={learnBtn}
                      alt='learn button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          openLearn();
                          setCheckStep('learn');
                        });
                      }}
                    />
                  )}

                {module15.stepCompleted === 'learn' && (
                  <img
                    className='actionBtn2'
                    src={practiceBtn}
                    id='bounceIcons'
                    alt='practice button'
                    onClick={() => {
                      touchSound.play()
                      sleep(500).then(() => {
                        openPractice();
                        setCheckStep('practice');
                      });
                    }}
                  />
                )}

                {module15.stepCompleted === 'practice' && (
                  <img
                    className='actionBtn2'
                    src={ftbBtn}
                    id='bounceIcons'
                    alt='celebrate button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openFTB();
                        setCheckStep('followthebeat');
                      });
                    }}
                  />
                )}

                {module15.stepCompleted === 'followthebeat' && (
                  <img
                    className='actionBtn2'
                    src={celebrateBtn}
                    id='bounceIcons'
                    alt='celebrate button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openCelebrate();
                        setCheckStep('celebrate');
                      });
                    }}
                  />
                )}

                {module15.stepCompleted === 'singingtime' && (
                  <img
                    className='actionBtn2'
                    src={learnBtn}
                    id='bounceIcons'
                    alt='singing button'
                    onClick={() => {
                      setTouchButton(true);
                      sleep(500).then(() => {
                        openLearn();
                        setCheckStep('learn');
                      });
                    }}
                  />
                )}
              </div>
            )}

          {!displayVoice && coinIcon && !disPlayPrize && (
            <div className='actionBtnDiv'>
              {module15.reviewIcon === false && (
                <img
                  id={coinAnimationState}
                  src={coinPick}
                  alt='reward key'
                  style={{
                    position: 'absolute',
                    top: '50vh',
                    left: '50vw',
                    width: '100px',
                    height: '100px',
                    marginLeft: '-50px',
                    marginTop: '-50px',
                    zIndex: 10,
                  }}
                  onClick={() => {
                    coinAnimation();
                  }}
                />
              )}
            </div>
          )}

          {!disPlayPrize &&
            !showAnimal &&
            !displayReward &&
            (
              <div className='actionBtnDiv'>
                {module15.reviewIcon && (
                <img
                  className={showReward ? 'actionBtn3' : 'actionBtn2'}
                  src={reviewBtn}
                  alt='review button'
                  onClick={() => {
                    setReviewIcon(!reviewIcon);
                  }}
                  />)}
                  {showReward && (
                    <img
                      src={rewardBtn}
                      className='actionBtn4'
                      alt='review button'
                      onClick={() => {
                        setTouchButton(true);
                        sleep(500).then(() => {
                          eggAnimation();
                        });
                      }}
                  />)}
                {module15.reviewIcon && reviewIcon && displayReview()}
              </div>
            )}

          {!coinIcon && keyIcon && !disPlayPrize && (
            <img
              className='rewardsIcon'
              id={keyState}
              style={{
                width: '150px',
                height: '40px',
                marginLeft: '-75px',
                zIndex: 10,
              }}
              src={keyReward}
              alt='reward key'
              onClick={() => {
                eggAnimation();
              }}
            />
          )}
          {displayReward && selectReward()}

          {!disPlayPrize && !coinIcon && presentIcon && (
            <img
              className='present'
              style={{
                width: '84px',
                height: '100px',
                marginLeft: '-42px',
                zIndex: 10,
              }}
              id='bounceIcons'
              src={present}
              alt='gift'
              onClick={() => {
                playSurpriseVideo();
              }}
            />
          )}
          {!disPlayPrize && !coinIcon && presentIcon && (
            <audio autoPlay>
              <source src={presentSound}></source>
            </audio>
          )}

          <div className='rewardArea'>
            <img className="Tree" src={Tree} alt="Tree" />

            {module15.rewards.TreeHouseRed.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module15.rewards.TreeHouseRed.x * clientWidth,
                  y: module15.rewards.TreeHouseRed.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(11, data);
                }}
              >
                <div
                  className='moveBigReward1'
                  style={{ backgroundImage: `url(${TreeHouseRed})` }}
                ></div>
              </Draggable>
            )}

            {module15.rewards.TreeHouseBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module15.rewards.TreeHouseBlue.x * clientWidth,
                  y: module15.rewards.TreeHouseBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(12, data);
                }}
              >
                <div
                  className='moveBigReward2'
                  style={{ backgroundImage: `url(${TreeHouseBlue})` }}
                ></div>
              </Draggable>
            )}

            {module15.rewards.Alien1.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module15.rewards.Alien1.x * clientWidth,
                  y: module15.rewards.Alien1.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(21, data);
                }}
              >
                <div
                  className='moveAlien1'
                  style={{ backgroundImage: `url(${Alien1})` }}
                ></div>
              </Draggable>
            )}

            {module15.rewards.Alien2.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module15.rewards.Alien2.x * clientWidth,
                  y: module15.rewards.Alien2.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(22, data);
                }}
              >
                <div
                  className='moveAlien2'
                  style={{ backgroundImage: `url(${Alien2})` }}
                ></div>
              </Draggable>
            )}

            {module15.rewards.TelescopeRed.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module15.rewards.TelescopeRed.x * clientWidth,
                  y: module15.rewards.TelescopeRed.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(31, data);
                }}
              >
                <div
                  className='moveTelescope1'
                  style={{ backgroundImage: `url(${TelescopeRed})` }}
                ></div>
              </Draggable>
            )}

            {module15.rewards.TelescopeBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module15.rewards.TelescopeBlue.x * clientWidth,
                  y: module15.rewards.TelescopeBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(32, data);
                }}
              >
                <div
                  className='moveTelescope2'
                  style={{ backgroundImage: `url(${TelescopeBlue})` }}
                ></div>
              </Draggable>
            )}

            {module15.rewards.CometBlue.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module15.rewards.CometBlue.x * clientWidth,
                  y: module15.rewards.CometBlue.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(41, data);
                }}
              >
                <div
                  className='moveComet1'
                  style={{ backgroundImage: `url(${CometBlue})` }}
                ></div>
              </Draggable>
            )}

            {module15.rewards.CometOrange.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module15.rewards.CometOrange.x * clientWidth,
                  y: module15.rewards.CometOrange.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(42, data);
                }}
              >
                <div
                  className='moveComet2'
                  style={{ backgroundImage: `url(${CometOrange})` }}
                ></div>
              </Draggable>
            )}

            {module15.rewards.Deer.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module15.rewards.Deer.x * clientWidth,
                  y: module15.rewards.Deer.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(51, data);
                }}
              >
                <div
                  className='moveDeer1'
                  style={{ backgroundImage: `url(${Deer})` }}
                ></div>
              </Draggable>
            )}

            {module15.rewards.Doe.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module15.rewards.Doe.x * clientWidth,
                  y: module15.rewards.Doe.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(52, data);
                }}
              >
                <div
                  className='moveDeer2'
                  style={{ backgroundImage: `url(${Doe})` }}
                ></div>
              </Draggable>
            )}

            {module15.rewards.Planet1.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module15.rewards.Planet1.x * clientWidth,
                  y: module15.rewards.Planet1.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(61, data);
                }}
              >
                <div
                  className='movePlanet1'
                  style={{ backgroundImage: `url(${Planet1})` }}
                ></div>
              </Draggable>
            )}

            {module15.rewards.Planet2.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module15.rewards.Planet2.x * clientWidth,
                  y: module15.rewards.Planet2.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(62, data);
                }}
              >
                <div
                  className='movePlanet2'
                  style={{ backgroundImage: `url(${Planet2})` }}
                ></div>
              </Draggable>
            )}

            {module15.rewards.Swing.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module15.rewards.Swing.x * clientWidth,
                  y: module15.rewards.Swing.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(71, data);
                }}
              >
                <div
                  className='moveSwing1'
                  style={{ backgroundImage: `url(${Swing})` }}
                ></div>
              </Draggable>
            )}

            {module15.rewards.TireSwing.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module15.rewards.TireSwing.x * clientWidth,
                  y: module15.rewards.TireSwing.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(72, data);
                }}
              >
                <div
                  className='moveSwing2'
                  style={{ backgroundImage: `url(${TireSwing})` }}
                ></div>
              </Draggable>
            )}

            {module15.rewards.Rocket1.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module15.rewards.Rocket1.x * clientWidth,
                  y: module15.rewards.Rocket1.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(81, data);
                }}
              >
                <div
                  className='moveRocket1'
                  style={{ backgroundImage: `url(${Rocket1})` }}
                ></div>
              </Draggable>
            )}

            {module15.rewards.Rocket2.unlocked && (
              <Draggable
                disabled={!displayGreenButton}
                bounds='parent'
                position={{
                  x: module15.rewards.Rocket2.x * clientWidth,
                  y: module15.rewards.Rocket2.y * clientHeight,
                }}
                onStop={(e, data) => {
                  onStop(82, data);
                }}
              >
                <div
                  className='moveRocket2'
                  style={{ backgroundImage: `url(${Rocket2})` }}
                ></div>
              </Draggable>
            )}

            {module15.rewards.BigNorthernLights.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module15.rewards.BigNorthernLights.x * clientWidth, y: module15.rewards.BigNorthernLights.y * clientHeight}}
                onStop={(e,data)=>{onStop(1, data)}}
                ><div className='movePrize15' style={{backgroundImage: `url(${NorthernLights})`}}></div></Draggable>}

            {module15.rewards.Galaxy.unlocked && <Draggable
                disabled={!displayGreenButton}
                bounds="parent"
                position={{x: module15.rewards.Galaxy.x * clientWidth, y: module15.rewards.Galaxy.y * clientHeight}}
                onStop={(e,data)=>{onStop(2, data)}}
                ><div className='movePrize25' style={{backgroundImage: `url(${Galaxy})`}}></div></Draggable>}
          </div>
        </div>
      )}
    </>
  );
};
export default Module15World;
